'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _FlexCenter = require('../../../components/misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeSuccess = function UnsubscribeSuccess(props) {
    return _react2.default.createElement(
        _FlexCenter2.default,
        { className: 'UnsubscribeSuccess' },
        _react2.default.createElement(
            'p',
            null,
            'You\'ve downgraded to the free plan.'
        ),
        _react2.default.createElement(
            _reactRouter.Link,
            { className: 'Button FormButton primary', to: '/' },
            'OK'
        )
    );
};

exports.default = UnsubscribeSuccess;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/unsubscribe/UnsubscribeSuccess.js
// module id = 2103
// module chunks = 0